module.exports = __webpack_public_path__ + "img/supercomp.ad448022.jpg";